/** localStorage keys used by {@link AuthService} and {@link authInterceptor}. */
export const AUTH_STORAGE_KEYS = {
  accessToken: 'accessToken',
  idToken: 'IdToken',
  refreshToken: 'refreshToken',
  requestedUrl: 'requestedUrl',
} as const;
